module.exports = __webpack_public_path__ + "static/logo-6992d24d505b8a7e405c8b03c92713bb.png";